import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import toastr from 'toastr';

export default {
  sharedFoldersReportController: [
    'runtimeConstant',
    '$scope',
    'revisionService',
    'dashboardService',
    '$filter',
    'folderService',
    '$rootScope',
    '$sce',
    function (
      runtimeConstant,
      $scope,
      revisionService,
      dashboardService,
      $filter,
      folderService,
      $rootScope
    ) {
      'use strict';

      function sortOperation(a, b, column) {
        var res = 0;

        switch (column.type) {
          case 'text':
            res = sortText(a, b, column);
            break;
          case 'number':
            res = sortNumber(a, b, column);
            break;
          case 'date':
            res = sortDate(a, b, column);
            break;
        }
        if (column.sorted === 'desc') return res * -1;

        return res;
      }

      function sortText(a, b, column) {
        if (column.sortExpression !== undefined) {
          var sort1 = $filter('reflect')(a, column.sortExpression);
          var sort2 = $filter('reflect')(b, column.sortExpression);

          if (sort1 === undefined) sort1 = '';
          if (sort2 === undefined) sort2 = '';
          return sort1.toString().localeCompare(sort2);
        } else {
          var value1 = $filter('reflect')(a, column.expression);
          var value2 = $filter('reflect')(b, column.expression);

          if (value1 === undefined) value1 = '';
          if (value2 === undefined) value2 = '';
          return value1.toString().localeCompare(value2);
        }
      }

      function sortNumber(a, b, column) {
        return column.sortExpression !== undefined
          ? $filter('reflect')(a, column.sortExpression) -
              $filter('reflect')(b, column.sortExpression)
          : $filter('reflect')(a, column.expression) -
              $filter('reflect')(b, column.expression);
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        if (column.sortExpression !== undefined) {
          firstDate = $filter('reflect')(a, column.sortExpression);
          secDate = $filter('reflect')(b, column.sortExpression);
        } else {
          firstDate = $filter('reflect')(a, column.expression);
          secDate = $filter('reflect')(b, column.expression);
        }
        var firstSplit = firstDate.split('/');
        var secSplit = secDate.split('/');
        firstDate = Date.parse(
          firstSplit[2] + '-' + firstSplit[1] + '-' + firstSplit[0]
        );
        secDate = Date.parse(
          secSplit[2] + '-' + secSplit[1] + '-' + secSplit[0]
        );
        if (firstDate > secDate) return 1;
        if (firstDate < secDate) return -1;
      }

      function updateSelectedFolder(item) {
        $scope.stateLinkFolder = item;
      }

      function populateForm() {
        $scope.sharedFolderPublic = [];
        let stateLinkFolderBoolean =
          $scope.stateLinkFolder.Id === 0 ? false : true;

        revisionService
          .getSharedFolder(stateLinkFolderBoolean)
          .then(function (data) {
            data.forEach(function (sharedFolder) {
              sharedFolder.Id = sharedFolder.IdFolder;
              sharedFolder.Link = $scope.getLink(sharedFolder.LinkSharedFolder);
              sharedFolder.Title = $scope.formatedTitle(
                sharedFolder.NameFolder
              );
              sharedFolder.Name = sharedFolder.NameOwner;
              sharedFolder.PublicLinkDate = $scope.LinkActiveDate(
                sharedFolder.SharedDate
              );

              $scope.sharedFolderPublic.push(sharedFolder);
            });

            if ($scope.sharedFolderPublic.length > 0) {
              $scope.showNotification(
                'success',
                'Sua pesquisa retornou: ' +
                  $scope.sharedFolderPublic.length +
                  ' itens.'
              );
            } else {
              $scope.showNotification('warning', 'Pesquisa sem resultado.');
            }
          });
      }

      function search() {
        $scope.populateForm();
      }

      function LinkActiveDate(date) {
        if (date === undefined) {
          return 'Ilimitado';
        } else {
          let arrayDate = date.substr(0, 10).split('-');
          return `${arrayDate[2]}/${arrayDate[1]}/${arrayDate[0]}`;
        }
      }

      function getLinkActive(data) {
        if (data.LinkSharedFolder !== undefined) {
          data.linkActive =
            window.location.origin + '/#/public/view/' + data.LinkSharedFolder;

          $scope.loading = false;
        }
      }

      function view(link) {
        var url = window.location.origin + '/#/login/autologin/' + link;
        window.open(url, '_blank');
      }

      function getLink(linkFolder) {
        var link = window.location.origin + '/#/login/autologin/' + linkFolder;
        return link;
      }

      function copyLinkActive(value) {
        var tempInput = document.createElement('input');
        tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        $scope.showNotification('info', 'PUBLIC LINK COPIED');
        document.body.removeChild(tempInput);
      }

      function cancelLinkSharedFolder(idFolder, folderTitle) {
        swal
          .fire({
            title: $filter('translate')('CANCEL'),
            text: `Deseja realmente cancelar o compartilhamento da pasta '${folderTitle}' ?`,
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showCancelButton: true,
          })
          .then(function () {
            folderService.deleteShared(idFolder).then(function () {
              $scope.isShowStatus = false;
              $scope.isSuccess = true;
              swal.fire(
                'Cancelado!',
                `O compartilhamento da pasta '${folderTitle}' foi cancelado.`,
                'success'
              );

              $scope.populateForm();
            });
          });
      }

      function showNotification(level, msg) {
        toastr.options = {
          closeButton: true,
          debug: false,
          progressBar: false,
          preventDuplicates: false,
          positionClass: 'toast-top-center',
          showDuration: '1000',
          hideDuration: '1000',
          timeOut: '7000',
          extendedTimeOut: '1000',
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut',
        };

        toastr[level]($filter('translate')(msg));
      }

      function close() {
        ModalInstance.dismiss('cancel');
      }

      function saveAsPdf() {
        var filter = {};
        filter.reportType = 12;
        filter.IsExpiryDate = $scope.stateLinkFolder.Id === 0 ? false : true;
        filter.FilterType = $scope.stateLinkFolder.Name;

        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });

        $scope.filter = filter;
        dashboardService
          .generatePublicLinkReport(filter)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function sortColumn(column) {
        if (column.sortable !== true) return;

        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';

        var sort = function (a, b) {
          return sortOperation(a, b, column);
        };
        $scope.sharedFolderPublic = $scope.sharedFolderPublic.sort(sort);

        var unsorted = $scope.columns.filter(function (c) {
          return c.id !== column.id;
        });

        unsorted.forEach(function (c) {
          c.sorted = undefined;
        });
      }

      function formatedTitle(title) {
        return $scope.truncateText(title, 75);
      }

      function truncateText(string, targetCharacterLength) {
        //preciso calcular o tamanho que as tags bold estao ocupando para ficar tudo com tamanho padrao
        targetCharacterLength +=
          (string.substr(0, 60).split('<b>').length - 1) * 3;
        targetCharacterLength +=
          (string.substr(0, 60).split('</b>').length - 1) * 3;

        var length = string.length;
        if (length < targetCharacterLength) {
          return string;
        } else {
          var shortenedString = string.slice(0, targetCharacterLength);
          var tempshortenedString = shortenedString.slice(
            0,
            shortenedString.lastIndexOf(' ')
          );

          var lastMarkupBegin = -1;
          var lastMarkupEnds = -1;
          try {
            lastMarkupBegin = tempshortenedString.lastIndexOf('<b>');
            lastMarkupEnds = tempshortenedString.lastIndexOf('<');
          } catch {}
          if (lastMarkupBegin !== -1) {
            // has an opening anchor tag
            if (lastMarkupEnds === -1) {
              // not having an closing tag
              tempshortenedString = tempshortenedString.slice(
                0,
                lastMarkupBegin
              );
              return tempshortenedString + '... ';
            }
          }

          var idx = shortenedString.lastIndexOf('<');
          var endTag = shortenedString.length - 4;
          if (idx >= endTag) {
            //aqui removemos o final da string caso ela tenha a abertura de alguma tag html
            shortenedString = shortenedString.substr(0, idx);
          }
          //se foi diminuido o tamanho da string comparado a original, então vou colocar tres pontos indicando que o titulo tem mais conteudo
          return shortenedString.length >= length - 4
            ? shortenedString
            : shortenedString + '... ';
        }
      }

      function run() {
        try {
          $scope.sharedFolderPublic = [];
          $scope.columns = [];
          $scope.documentTypes = [];
          $scope.filter;

          $scope.stateLinkFolder = null;
          $scope.stateLinkFolderList = [
            { Name: '-- TODOS --', Id: 0 },
            { Name: '-- EXPIRADOS --', Id: 1 },
          ];

          $scope.updateSelectedFolder = logWrapper(
            updateSelectedFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.populateForm = logWrapper(
            populateForm,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.search = logWrapper(
            search,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.LinkActiveDate = logWrapper(
            LinkActiveDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLinkActive = logWrapper(
            getLinkActive,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.view = logWrapper(
            view,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLink = logWrapper(
            getLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.copyLinkActive = logWrapper(
            copyLinkActive,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelLinkSharedFolder = logWrapper(
            cancelLinkSharedFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showNotification = logWrapper(
            showNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.close = logWrapper(
            close,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveAsPdf = logWrapper(
            saveAsPdf,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumn = logWrapper(
            sortColumn,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedTitle = logWrapper(
            formatedTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.truncateText = logWrapper(
            truncateText,
            runtimeConstant.isDebugControllersInternals
          );

          $rootScope.$broadcast('clearSearchTerm');

          $scope.columns = [
            {
              id: 'title',
              width: '40%',
              header: $filter('translate')('COLUMN.TITLE'),
              expression: 'Title',
              style: {
                'min-width': '150px',
              },
              sortExpression: 'Title',
              tooltip: 'tooltipTitle()',
              dataPriority: 2,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'name',
              width: '15%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              expression: 'Name',
              style: {
                'min-width': '20px',
              },
              sortExpression: 'Name',
              mobileShow: false,
              visible: true,
              dataPriority: 5,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'publicLinkDate',
              width: '20%',
              header: 'Validade',
              expression: 'PublicLinkDate',
              style: {
                'min-width': '20px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 5,
              disabled: false,
              sortable: true,
              type: 'text',
            },
          ];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
